import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
/* eslint-disable @typescript-eslint/no-var-requires */
import { DomSanitizer, SafeUrl, SafeHtml } from '@angular/platform-browser';

const heroImagePath = require('./report-illo-faded.svg').default;

export enum ContentType {
  collection = 'collection',
}

@Component({
  selector: 'mode-error-prompt',
  templateUrl: './error-prompt.component.html',
  styleUrls: ['./error-prompt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPromptComponent {
  safeHeroImageUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(heroImagePath);

  @Input()
  contentType!: ContentType;

  @Input()
  explanation!: SafeHtml;

  @Input()
  instructions!: string;

  @Input()
  title!: string;

  @Input()
  setCustomCss!: boolean;

  constructor(private sanitizer: DomSanitizer) {}
}
